import Vue from "vue";
import FormWrapper from "./form-wrapper";

window.addEventListener("DOMContentLoaded", () => {
  // Form
  const formMount = document.querySelector('artist-filters-form');
  const dataExhibitionTitle = formMount.getAttribute("data-exhibition-title");
  const dataFilteredTotal = parseInt(formMount.getAttribute("data-filtered-total"));
  const dataTotal = parseInt(formMount.getAttribute("data-total"));
  const paramExhibitionId = parseInt(formMount.getAttribute("param-exhibition-id"));
  const paramSearchTerm = formMount.getAttribute("param-search-term");
  const paramSortRandomSeed = parseFloat(formMount.getAttribute("param-sort-random-seed"));
  const paramWithOnlineWorks = formMount.getAttribute("param-with-online-works") === "true";

  // Filter/pagination
  const paginationMount = document.querySelector("[data-pagination-mount]");
  const dataFetchBaseURL = paginationMount.getAttribute("data-fetch-base-url");
  const dataLastPage = parseInt(paginationMount.getAttribute("data-last-page"));
  const dataShowMoreItemsButtonHTML = paginationMount.getAttribute('data-show-more-items-button-html');

  // Recommended list
  const recommendedListMount = document.querySelector("section[section='artists']");
  const dataRecommendedJsonUrl = recommendedListMount.getAttribute("data-url");
  const dataRecommendedPageTitle = recommendedListMount.getAttribute("data-page-title");
  const dataRecommendedLinkBasePath = recommendedListMount.getAttribute("data-link-base-path");

  new Vue({
    el: formMount,
    components: {
      FormWrapper
    },
    data: {
      // Form
      dataExhibitionTitle: dataExhibitionTitle,
      dataFilteredTotal: dataFilteredTotal,
      dataTotal: dataTotal,
      paramExhibitionId: paramExhibitionId,
      paramSearchTerm: paramSearchTerm,
      paramSortRandomSeed: paramSortRandomSeed,
      paramWithOnlineWorks: paramWithOnlineWorks,

      // Filter/pagination
      dataFetchBaseURL: dataFetchBaseURL,
      dataLastPage: dataLastPage,
      dataShowMoreItemsButtonHTML: dataShowMoreItemsButtonHTML,

      // Recommended list
      dataRecommendedJsonUrl: dataRecommendedJsonUrl,
      dataRecommendedPageTitle: dataRecommendedPageTitle,
      dataRecommendedLinkBasePath: dataRecommendedLinkBasePath,
    },
    template: `
      <FormWrapper
        :data-exhibition-title=dataExhibitionTitle
        :dataFilteredTotal=dataFilteredTotal
        :dataTotal=dataTotal
        :param-with-online-works=paramWithOnlineWorks
        :param-exhibition-id=paramExhibitionId
        :param-search-term=paramSearchTerm
        :param-sort-random-seed=paramSortRandomSeed

        :dataFetchBaseURL=dataFetchBaseURL
        :dataLastPage=dataLastPage
        :dataShowMoreItemsButtonHTML=dataShowMoreItemsButtonHTML

        :dataRecommendedJsonUrl=dataRecommendedJsonUrl
        :dataRecommendedPageTitle=dataRecommendedPageTitle
        :dataRecommendedLinkBasePath=dataRecommendedLinkBasePath
      />
    `
  });
});
